import { AvatarPrimitive, styled } from '@arpeggi/ui'
import { observer } from 'mobx-react-lite'
import { ComponentProps, FC, forwardRef } from 'react'
import { Link } from 'react-router-dom'
import ProfileRegistry from '../../../../stores/registry/ProfileRegistry'
import { ConditionalWrapper } from '../../../core/ConditionalWrapper'
import withTooltip from '../../../core/withTooltip'

const AvatarRoot = withTooltip(
  styled(AvatarPrimitive.Root, {
    width: '32px',
    height: '32px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    background: '$gray0100',
    boxSizing: 'border-box',
    borderRadius: '999px',
    variants: {
      bordered: {
        true: {
          borderStyle: 'solid',
          borderWidth: '1px',
          borderColor: '$white'
        }
      },
      square: {
        true: {
          borderRadius: '5px'
        }
      },
      large: {
        true: {
          width: '48px',
          height: '48px'
        }
      }
    }
  })
)

const AvatarImage = styled(AvatarPrimitive.Image)

const AvatarFallback = styled(AvatarPrimitive.Fallback)

interface AvatarProps {
  eth: string
  isTooltipDisabled?: boolean
  showLink?: boolean
}

const Avatar: FC<ComponentProps<typeof AvatarRoot> & AvatarProps> = forwardRef(
  ({ eth, isTooltipDisabled, showLink = true, ...props }, ref) => {
    const profile = ProfileRegistry.getByIndexReactive(eth)
    const text = (profile && (profile.display_name || eth)) || 'Loading'
    const link = `/profile/${eth}/created/songs`

    return (
      <ConditionalWrapper
        condition={showLink}
        wrapper={(children) => (
          <Link onClick={(e) => e.stopPropagation()} to={link}>
            {children}
          </Link>
        )}
      >
        <AvatarRoot ref={ref} tooltipText={text} isDisabled={isTooltipDisabled} {...props}>
          <AvatarImage src={profile && profile.profile_picture} />
          <AvatarFallback delayMs={2000} />
        </AvatarRoot>
      </ConditionalWrapper>
    )
  }
)

export default observer(Avatar)
